import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

export const getAllSubscriptionsByMembershipId = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/membership/${id}/subscriptions`);

export const getAllProductsBySubscription = (subid) =>
  apiClient.get(`${REST_API_BASE_URL}/subscription/${subid}/products`);

export const getAllGroupsBySubscription = (subid) =>
  apiClient.get(`${REST_API_BASE_URL}/subscription/${subid}/groups`);

export const saveSubscriptionByMembership = (id, subscription) =>
  apiClient.post(
    `${REST_API_BASE_URL}/membership/${id}/subscription`,
    subscription,
  );

export const getSubscription = (id, subid) =>
  apiClient.get(`${REST_API_BASE_URL}/membership/${id}/subscription/${subid}`);

export const updateSubscription = (id, subscription) =>
  apiClient.put(`${REST_API_BASE_URL}/subscription/${id}`, subscription);

export const deleteSubscription = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/subscription/${id}`);

export const addProductBySubscription = (subid, prodid) =>
  apiClient.post(
    `${REST_API_BASE_URL}/subscription/${subid}/product/${prodid}`,
  );

export const addGroupBySubscription = (subid, groupid) =>
  apiClient.post(`${REST_API_BASE_URL}/subscription/${subid}/group/${groupid}`);

export const removeProductFromSubscription = (subid, prodid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/subscription/${subid}/product/${prodid}`,
  );

export const removeGroupFromSubscription = (subid, groupid) =>
  apiClient.delete(
    `${REST_API_BASE_URL}/subscription/${subid}/group/${groupid}`,
  );

export default apiClient;
